import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import {
  formatBenchmarkValue,
  getDetailScalePercent,
} from 'pages/pga-coach/dashboard/performance-benchmarks/utils'

const BenchmarkScale = ({ metric, classes }) => {
  const gettingStartedPercent = getDetailScalePercent(
    metric.gettingStartedValue,
    metric,
  )
  const coachPercent = getDetailScalePercent(metric.coachValue, metric)
  const medianPercent = getDetailScalePercent(metric.medianValue, metric)
  const top10Percent = getDetailScalePercent(metric.top10Value, metric)

  return (
    <Box className={classes.scaleSection}>
      <Box className={classes.metricValueRow}>
        <Typography className={classes.metricValue}>
          {formatBenchmarkValue(metric.coachValue, metric.unit)}
        </Typography>
        <Box className={classes.scaleValuesRow}>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>Median</Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.medianValue, metric.unit)}
            </Typography>
          </Box>
          <Box className={classes.scaleValueGroup}>
            <Typography className={classes.scaleValueLabel}>Top 10%</Typography>
            <Typography className={classes.scaleValue}>
              {formatBenchmarkValue(metric.top10Value, metric.unit)}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className={classes.scaleTrack} aria-hidden>
        <Box
          className={classes.scaleCoachMarker}
          style={{ left: `${coachPercent}%` }}
        />
        <Box
          className={classes.scaleTick}
          style={{ left: `${medianPercent}%` }}
        />
        <Box
          className={classes.scaleTick}
          style={{ left: `${top10Percent}%` }}
        />
      </Box>

      <Box className={classes.scaleLabelsRow}>
        <Typography
          className={classes.scaleLabel}
          style={{ left: `${gettingStartedPercent}%` }}
        >
          Getting started
        </Typography>
        <Typography
          className={`${classes.scaleLabel} ${classes.scaleLabelCenter}`}
          style={{ left: `${medianPercent}%` }}
        >
          Median
        </Typography>
        <Typography
          className={`${classes.scaleLabel} ${classes.scaleLabelEnd}`}
          style={{ left: `${top10Percent}%` }}
        >
          Top 10%
        </Typography>
      </Box>
    </Box>
  )
}

BenchmarkScale.propTypes = {
  metric: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default BenchmarkScale
